<template>
  <div class="info-item" @click="goPage">
    <div ref="coverImg" class="info-item-img" :style="{'height': imgHeight}">
      <img v-if="data.coverUrls" :src="data.coverUrls[0] | imageToHttps | imageToWebp($webpSurpport)"/>
    </div>
    <div class="info-body">
      <h5>{{data.title}}</h5>
      <div class="info-flex">
        <div>
          <div class="info-user"><img :src="data.user && data.user.icon"/></div>
          <span>{{data.user && data.user.nickname}}</span>
        </div>
        <div><span>{{data.likeCount}}赞</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'infoItem',
  props: ['data'],
  data() {
    return {
      imgWidth: ''
    }
  },
  computed: {
    imgHeight() {
      let imgInfo = this.$util.strJSONParse(this.data.coverUrlInfo)
      let imgHeight = imgInfo ? (this.imgWidth * imgInfo[0].height) / imgInfo[0].width + 'px' : 'auto'
      return imgHeight
    }
  },
  mounted() {
    this.$util.setTimeOutFn(() => {
      this.imgWidth = this.$refs.coverImg && this.$refs.coverImg.offsetWidth
    })
  },
  methods: {
    goPage() {
      this.$emit('handleClick')
    }
  }
}
</script>

<style lang="scss" scoped>
.info-item-img{
  >img{
    width: 100%;
    height: 100%;
  }
}

.info-body{
  padding: .24rem .2rem;
  >h5{
    font-size: .26rem;
    @include text-overflow(2)
  }
}
.info-flex{
  margin-top: .16rem;
  display: flex;
  justify-content: space-between;
  > div{
    flex: 1;
    display: flex;
    align-items: center;
    font-size: .24rem;
    color: #333;
    &:first-child{
      flex: 2
    }
    &:last-child{
      justify-content: flex-end;
    }
    span{
      display: inline-block;
      margin-left: .12rem;
      @include text-overflow(1);
    }
  }
}
.info-user{
  position: relative;
  width: .44rem;
  display: inline-block;
  img{
    width: .44rem;
    height: .44rem;
    border-radius: .22rem;
  }
  &::after{
    position: absolute;
    bottom: 0;
    right: -.1rem;
    content: '';
    width: .28rem;
    height: .28rem;
    background: url(data:image/png;base64,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);
    background-size: contain;
    z-index: 2;
  }
}
</style>
